<router-outlet>
    <ngx-ui-loader></ngx-ui-loader>
</router-outlet>